module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/171-galapagos-islands-4591cba4912c1ae77703b0a57ea29e53.svg";